<section id='tax-maint'>
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <!-- Container for Tax Table using prime ng -->
        <div class = 'table-tax'>
            <osp-table [tblConfig]="tblConfigTax" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="generate-tax-form">
            <div class="form-loader"></div>
        </div>
        
        <!-- Container for Tax Fields -->
        <div class="form-content">
            
            <form [formGroup]="taxForm" class="form" *ngIf="noLoadingInProcess">
                <div id="tax-error-message"></div>
                <div class="form-container-grid">
                    <div class="field">
                        <label>Tax Code</label>
                    </div>
                    <div class="">
                        <input formControlName="taxCode" type="text" readonly>
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option value="A" selected>Yes</option>
                            <option value="I">No</option>
                        </select>
                    </div>

                    <div class="field required">
                        <label>Tax Name</label>
                    </div>
                    <div class="">
                        <input formControlName="taxName" type="text" maxlength="50">
                    </div>
                    <div class="field">
                        <label>Other Charges</label>
                    </div>
                    <div class="">
                        <select formControlName="ocTag">
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>

                    <div class="field">
                        <label>Tax Short Name</label>
                    </div>
                    <div class="">
                        <input formControlName="taxShortName" type="text" maxlength="5">
                    </div>
                    <div>
                    </div>
                    <div>
                    </div>

                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>

                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUserUpdate">
                    </div>

                </div>
                <div class='btn-row'>
                    <button type="button" id='btn-add' *ngIf="!isTaxSelected" title='Register a new tax' class="btn btn2" value='ADD' type="submit" (click)='insertTax()'>ADD</button>
                    <button type="button" id='btn-update' *ngIf="isTaxSelected" title='Update a tax' class="btn btn2" value='UPDATE' type="submit" (click)='updateTax()'>UPDATE</button>
                    <button type="button" id='btn-delete' title='Remove a tax' class="btn btn2" value='DELETE' type="submit" (click)='deleteTax()' [disabled]='deleteDisabled'>DELETE</button>
                </div> 

                <div class="mtn-title"></div>

                <div class='btn-row'>
                    <button type="button" id='btn-save' title='Save changes on tax details' class="btn btn2" value='SAVE' type="submit" (click)='toSave()' [disabled]='saveDisabled'>SAVE</button>
                </div>
            </form>
        </div>  
    </div>
</section>
